// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-v2-creator-editor .assignee-section:not(:last-child) {
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./Source/app/task-v2/fi-task-v2-details/task-v2-assignee/task-v2-creator-editor/task-v2-creator-editor.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR","sourcesContent":[".fi-task-v2-creator-editor {\r\n    .assignee-section:not(:last-child) {\r\n        margin-bottom: 24px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
